<template>
  <div class="contact-bar block has-text-right pt-4">
    <span
      class="has-text-centered has-text-white has-background-primary p-4"
      style="font-family: marca"
    >
      MAKE THE DIFFERENCE
    </span>
    <span
      class="contact has-text-centered has-text-white has-text-weight-bold has-background-yellow p-4"
      style="font-family: marca"
    >
      CONTACTO
    </span>
    <span
      class="button is-inverted"
      style="background: none; border: none; vertical-align: middle"
    >
      <figure class="image is-48x48">
        <img src="../assets/WhatsApp.svg" />
      </figure>
    </span>
  </div>
</template>
